import React from 'react';
import { IconProps } from '@/models/IconProps';

const PauseIcon: React.FC<IconProps> = ({ height = '24', width = '24', strokeColor = '#1F2126' }) => {
  return (
    <svg width={width} height={height} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M9.99771 0H1.98877V24H9.99771V0ZM22.0111 0H14.0022V24H22.0111V0Z" fill={strokeColor} />
    </svg>
  );
};

export default PauseIcon;
